// Maximum expected Stripe fee for a credit card purchase
export const STRIPE_FEE_PERCENT = '0.035';

// Number of total cents for the flat fee portion of the stripe processing fee
export const STRIPE_TX_FEE = '30';

// Per-ticket modifier for Side Door fees
// Side Door expects $1.50 (or equivalent thereof in local currency) per ticket
// November 3, 2021 - Increase fee to 200 for 2.27.0
// December 13, 2023 - Increase fee to 300 for 4.3.0
export const SIDE_DOOR_FEE_MOD = '300';
